import { z } from 'zod';

/**
 * Sign Up Form Schema — email only.
 * Organization is selected after activation.
 */

export const getSignupFormValidationSchema = (t: (key: string) => string) =>
  z.object({
    email: z
      .string()
      .email({ message: t('INVALID_EMAIL_ADDRESS') })
      .min(1, { message: t('EMAIL_NAME_CANT_EMPTY') }),
  });

export type signupFormType = z.infer<ReturnType<typeof getSignupFormValidationSchema>>;

export const signupFormDefaultValue: signupFormType = {
  email: '',
};
